module.exports = __webpack_public_path__ + "static/media/tuv-tk44727.2220e330.jpg";